import { observable } from "mobx";
import { Type } from "class-transformer";
import OutgoingPayGateTransactionDetailResponse from "./outgoingPayGateTransactionDetailResponse";
import RefundChargeResponse from "./refundChargeResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class OutgoingPayGatePaymentDetailResponse {
  @observable
  @Type(() => OutgoingPayGateTransactionDetailResponse)
  outgoingPayment!: OutgoingPayGateTransactionDetailResponse;

  @observable
  @Type(() => RefundChargeResponse)
  refundCharge?: RefundChargeResponse;
}
